import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { UsefulInfoDetailInitStepDeclaration } from "./Steps/UsefulInfoDetailInitStep";

export const UsefulInfoDetailStartupFlow = new FlowDefinition(
  "UsefulInfoDetailFlow"
);

UsefulInfoDetailStartupFlow.addStep(UsefulInfoDetailInitStepDeclaration);

UsefulInfoDetailStartupFlow.setStartStep("UsefulInfoDetailInit_Step");

export const UsefulInfoDetailStartupStepDefinition = new StepDefinition({
  stepName: "UsefulInfoDetailFlow",
  stepFlow: UsefulInfoDetailStartupFlow,
  contextIsolation: false,
});
